class MediaResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource,
        configService
    ) {
        return headers => {
            return $resource(configService.contentApi.url + "/v1/medias/:id", {id: "@id"}, {
                deleteMedia: {
                    method: "DELETE"
                },
                updateMedia: {
                    method: "PATCH"
                }
            });
        };
    }
}

angular
    .module("thor.core.media.resource", [])
    .factory("mediaResource", MediaResource);
